export const AUTH_CONFIG = {
  domain: 'login.oauthplayground.westondemos.co.uk',
  clientId: 'mbMSqGBmpboU2Q4xQRQB1XC0oudRkIAV',
  // callbackUrl: 'http://localhost:3000/callback',
  container: 'auth0-login-container'
}
